const tr = {
    addMember: '添加成員',
    avatar: '頭像',
    phNumber: '手機號',
    permissions: '權限',
    isAdmin: '是否為系統管理員',
    acntExists: '帳號已存在',
    addSuccess: '添加成功',
    addFailed: '添加失敗',
    tips: '提示',
    confirmAction: '您確定要',
    disable: '禁用',
    enable: '啟用',
    bascInfoUp: '基本資訊修改成功',
    userPerSetSuc: '用戶許可權設定成功',
    pwdChanged: '密碼修改成功',
    mobileChangeSuc: '手機號修改成功',
    aginLogin: '請重新登入!',
    validaFailed: '校驗失敗',
    pwd: '密碼',
    enterPwd: '請輸入密碼',
    pwdMinLength: '密碼至少6位',
    plConfirmPwd: '請確認密碼',
    confirmPwd: '確認密碼',
    pwdDiff: '兩次密碼不一致',
    reenterPwd: '請再次確認密碼',
    memberDetails: '成員詳情',
    basicInfo: '基本資訊',
    searchPrompt: '請輸入name1、name2、手機號進行蒐索',
    sure: '確定',
    viewDetails: '看詳情',
    thisMember: '該成員嗎',
    maxLengthTip: '內容超出最大長度限制！',
    changeStatusSucc: '操作成功!',
    phNumberTip: '請輸入手機號',
    updateFail: '修改失敗',
    userDataNoExistTip: '用戶數據不存在或用戶被禁用',
    mobileEmpty: '手機號不能為空',
    userFetchFail: '獲取用戶資訊失敗',
    name1: '姓名1',
    name2: '姓名2',
};

export default tr;